var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.738 25.867c.28 0 .597-.067.83-.3.232-.232.3-.55.3-.829V10.062c0-.28-.068-.588-.3-.82-.233-.233-.55-.309-.83-.309h-5.08a.566.566 0 0 0-.404.966.565.565 0 0 0 .404.163h5.08v14.676H10.062v-5.08a.565.565 0 1 0-1.13 0v5.08c0 .28.068.597.3.83.233.232.55.3.83.3h14.676zm-22.676-8a1.14 1.14 0 0 1-1.129-1.129V2.062A1.14 1.14 0 0 1 2.062.933h14.676a1.14 1.14 0 0 1 1.13 1.129v14.676a1.14 1.14 0 0 1-1.13 1.13z",
    fill: "#000",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.067 9.567v4h-1v-4h-3.5l4-4 4 4z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendForward);
export default __webpack_public_path__ + "static/media/send-forward.a487d7f166a30bee10d361803ee0319a.svg";
export { ForwardRef as ReactComponent };